module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }, [(_vm.placeholder) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.neighborhoods), function(neighborhood) {
    return (Array.isArray(_vm.neighborhoods)) ? _c('option', {
      domProps: {
        "value": neighborhood.id,
        "selected": _vm.value == neighborhood.id
      }
    }, [_vm._v("\n      " + _vm._s(neighborhood.name) + "\n    ")]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f2f8d7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputNeighborhoods.vue
// module id = 988
// module chunks = 34